// Logo na etykietach sprzętu (24.10.2026). Czyste reguły bez React i sieci.
//
// Etykieta nie ma już nazwy sprzętu: w jej miejscu stoi logo firmy. Firma może wgrać osobne
// logo etykiet (`contract_settings.label_logo`, migracja 066), bo na naklejce sprawdza się
// zwykle inna wersja niż na umowie (jednokolorowa, pozioma, bez tła). Bez niego etykieta bierze
// logo z „Danych firmy”, a bez obu drukuje się bez logo.

export const LABEL_LOGO_TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'];
// Ten sam limit co logo w „Danych firmy” (pages/ContractSettings.js); serwer przyjmuje do 1,5 MB
// w zapisie base64, czyli ok. 1,1 MB pliku.
export const LABEL_LOGO_MAX_BYTES = 1024 * 1024;

/** Które logo drukować: `{ src, source }`, gdzie source to 'label', 'company' albo null. */
export function effectiveLabelLogo(settings) {
  const s = settings || {};
  const obraz = (v) => (typeof v === 'string' && v.startsWith('data:image/') ? v : null);
  const wlasne = obraz(s.label_logo);
  if (wlasne) return { src: wlasne, source: 'label' };
  const firmy = obraz(s.company_logo);
  if (firmy) return { src: firmy, source: 'company' };
  return { src: null, source: null };
}

/** `null` albo klucz błędu: 'type' (nie obraz z listy) albo 'size' (za duży plik). */
export function labelLogoFileError(file) {
  if (!file) return 'type';
  if (!LABEL_LOGO_TYPES.includes(file.type)) return 'type';
  if (file.size > LABEL_LOGO_MAX_BYTES) return 'size';
  return null;
}
